import { ACTIVITY_SECTIONS } from 'constants/enums'

export default function(fields = {}) {
  let sectionsReturnedToInProgress = []
  const keys = ACTIVITY_SECTIONS.list.map(item => item.value)

  keys.forEach(key => {
    if (fields[key]) {
      sectionsReturnedToInProgress = sectionsReturnedToInProgress.concat(key)
    }
  })

  return {
    approved: false,
    note: fields.note,
    sectionsReturnedToInProgress
  }
}
